import { Close } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material';
import React, { useEffect } from 'react';

import usePrompt from '../../hooks/usePrompt';

interface IProps {
  value: string;
}

const FuelPrompt = ({ value }: IProps) => {
  const { onConfirm, onCancel } = usePrompt();
  const [open, setOpen] = React.useState(false);
  const [val, setVal] = React.useState(null);

  useEffect(() => {
    if (value) {
      setVal('');
      setOpen(true);
    }
  }, [value]);

  const handleConfirm = (event: React.SyntheticEvent | Event, reason?: string) => {
    setVal('');
    setOpen(false);
    onConfirm(val);
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
    onCancel();
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
      <DialogTitle>{value}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <TextField defaultValue={val} onChange={(event) => setVal(event.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Cancel
        </Button>
        <Button color="success" variant="contained" onClick={handleConfirm}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FuelPrompt;
